var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 15,
    height: 4,
    fill: "url(#paint0_linear_6853_16910)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1916 12.9119L19.1916 9.33542C19.1932 8.16283 18.2353 7.21257 17.055 7.21404L5.96505 7.22967C4.78935 7.23209 3.83616 8.17753 3.8342 9.34473L3.82397 16.4846C3.82236 17.6572 4.78025 18.6074 5.96062 18.6059L13.3451 18.6059",
    stroke: "#353535",
    strokeWidth: 1.41455,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68164 10.8848H18.6185",
    stroke: "#353535",
    strokeWidth: 1.41455
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1983 17.731L21.313 16.8457L20.4277 17.731",
    stroke: "#353535",
    strokeWidth: 1.0429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7051 18.3203L16.5904 19.2056L17.4757 18.3203",
    stroke: "#353535",
    strokeWidth: 1.0429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5918 19.2052V16.8445C16.5918 16.1921 17.1198 15.6641 17.7722 15.6641H19.5428",
    stroke: "#353535",
    strokeWidth: 1.0429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3119 16.8457V19.2065C21.3119 19.8557 20.7807 20.3869 20.1315 20.3869H18.3672",
    stroke: "#353535",
    strokeWidth: 1.0429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6853_16910",
    x1: 4,
    y1: 7,
    x2: 26.9306,
    y2: 17.1637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfert);
export default __webpack_public_path__ + "static/media/transfert.73e0fcea0087688854c9227893928475.svg";
export { ForwardRef as ReactComponent };